import { useAuth } from "@/providers/auth-provider";

/**
 * True when both ids are non-empty strings and equal (Kinde user id;
 * matches `UserResponse.id` and `/settings/users/:user_id`).
 */
export function isSameKindeUserId(
	a: string | undefined,
	b: string | undefined,
): boolean {
	return Boolean(a && b && a === b);
}

/**
 * Signed-in user's Kinde id from the auth session (no `/me` round trip).
 *
 * `isAuthResolved` is false while Kinde is still loading — compare to other ids
 * only after resolution so UI does not briefly treat the current user as
 * "not self" (e.g. enabling Manage on your own row).
 */
export function useAuthKindeUserId() {
	const { authUser, isLoadingAuth } = useAuth();

	return {
		isAuthResolved: !isLoadingAuth,
		kindeUserId: authUser?.id,
	};
}
